(function () {
  "use strict";

  var PARAMS = new URLSearchParams(location.search);
  // Store build (theme section radiancy-vsl-page): #player carries data-video = the protected stream
  // (<worker>/p/<cut>, see the "Protected stream" block) or, for a rollback, a plain hosted mp4 / HLS (.m3u8) URL.
  // The store build has no review mode and no local fallback clip; everything else is identical.
  var STORE_SRC = (document.getElementById("player").getAttribute("data-video") || "").trim();
  var PROTECTED = /^(https?:\/\/[^\/?#]+\/p\/([a-z0-9-]{1,32}))\/?$/.exec(STORE_SRC);
  // Blake's review mode (?review=1, local preview only): real scrubbing, speed, ±5 s keys, chapters, offer shown at
  // once. It never reads or writes the visitor's saved position or reveal state.
  var REVIEW = !STORE_SRC && PARAMS.get("review") === "1";
  // The final cut (d4-v4, Blake 2026-09-30). Visitors always get it; data-reveal-at and the end-card auto-click are
  // timed on its clock. Review mode can switch cuts: ?review=1&v=<name> plays render/vsl-final-<name>.mp4, v= (empty)
  // plays render/vsl-final.mp4.
  var FINAL_CUT = "blake-v4";
  var CUT = REVIEW && PARAMS.has("v") && /^[a-z0-9-]*$/.test(PARAMS.get("v")) ? PARAMS.get("v") : FINAL_CUT;
  var PRIMARY = cutSrc(CUT);
  var FALLBACK = "../assets/tests/sd-crystals.mp4";
  var LS_TIME = "vsl08:currentTime";
  var LS_REVEALED = "vsl08:revealed";
  // Reference return-visit rule: a session cookie set on the first view; any later load in the session shows the offer.
  var VISIT_COOKIE = "btlv2";
  var VISIT_VALUE = "video1";
  var REWIND_SECONDS = 10;
  var CONTROLS_IDLE_MS = 2200;
  var TYPE_MS = 24;          // per character; the reference types its three lines in about 2 s
  var TYPE_LOOP_MS = 10000;  // the reference pause GIF loops every 10 s and re-types
  var CHAPTERS = "../render/vsl-final" + (CUT ? "-" + CUT : "") + ".chapters.txt";
  var REVIEW_SEEK_SECONDS = 5;
  var chapterItems = [];

  // QA helpers for the visitor view (no effect on Blake's review mode):
  // ?fresh=1 forgets the saved position, the reveal and the visit cookie (a true first visit);
  // ?t=<seconds> starts the video there once "Click Here" is tapped, to test the reveal / end card without a 34-min watch.
  if (!REVIEW && PARAMS.get("fresh") === "1") {
    try { localStorage.removeItem(LS_TIME); localStorage.removeItem(LS_REVEALED); } catch (err) {}
    document.cookie = VISIT_COOKIE + "=; max-age=0; path=/";
  }
  var DEBUG_T = REVIEW ? 0 : Math.max(0, parseFloat(PARAMS.get("t")) || 0);

  var video = document.getElementById("vsl");
  var overlay = document.getElementById("listen-overlay");
  var progressBar = document.getElementById("progress-bar");
  var resumeBox = document.getElementById("resume");
  var player = document.getElementById("player");
  var rewindBtn = document.getElementById("rewind");
  var pauseScreen = document.getElementById("pause-screen");
  var keepBtn = document.getElementById("keep-watching");
  var typed = document.getElementById("pause-typed");
  var film = document.getElementById("film");
  // Reference: a hidden CTA the player auto-clicks near the end (player.onTime(1990) → #scrollcta.click()).
  var endCta = document.getElementById("scrollcta");
  var endCtaAt = endCta ? parseFloat(endCta.getAttribute("data-at")) : NaN;
  var endCtaFired = false;

  var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // Start mode (theme section setting "Start mode", read from #player[data-start-mode]):
  //   sound (default): the video never plays muted. It waits paused on its poster behind one tap target; the first tap
  //     starts it with sound (and resumes from the saved position when the visitor chose "Continue").
  //   muted: the old flow, a muted autoplay preview behind "Click Here", restarted from 0 with sound on the tap.
  var MUTED_START = (player.getAttribute("data-start-mode") || "").trim() === "muted";
  player.classList.add(MUTED_START ? "start-muted" : "start-sound");
  // Muted mode only (theme settings, #player data attributes):
  //   data-sound-prompt="1": the full-player sound prompt replaces the "Click Here" box; its line choice
  //     (data-prompt-line) is recorded once per page load as the tracker event sound_prompt (data = the line number).
  //   data-captions="1": the spoken line over the muted video, from window.VSL_CAPTIONS[<cut id>] (captions.js).
  var SOUND_PROMPT = MUTED_START && player.getAttribute("data-sound-prompt") === "1";
  var PROMPT_LINE = (player.getAttribute("data-prompt-line") || "").trim();
  var cues = MUTED_START && player.getAttribute("data-captions") === "1" ? captionCues() : [];
  var captionBox = document.getElementById("mute-captions");
  var captionText = document.getElementById("mute-caption-text");
  var cueIndex = -1;
  var promptTracked = false;
  // The markup carries these classes for the first paint; a cut with no caption timeline drops has-captions here.
  player.classList.toggle("has-sound-prompt", SOUND_PROMPT);
  player.classList.toggle("has-captions", cues.length > 0);
  var unmutedOnce = false;
  var keepResumeTime = false;
  var allowSeek = false;
  var lastLegalTime = 0;
  var lastSavedVideoTime = 0;
  var usingFallback = false;
  var pendingResume = 0;
  var controlsTimer = 0;
  var savedTime = readSavedTime();
  var revealed = readRevealed();
  // Protected stream state (see "Protected stream" below). mode: hlsjs | native | mp4. swapAt >= 0 while a recovery
  // swaps the source at that time (the seek guard and lastLegalTime ignore the element's interim 0).
  var stream = { attached: !PROTECTED, mode: "", urls: null, hls: null, minting: null, wantPlay: false, waiters: [],
    fails: 0, lastFail: 0, mediaRecovered: false, recovering: false, mp4Rescues: 0 };
  var swapAt = -1;

  video.controls = false;
  video.setAttribute("controlsList", "nodownload noplaybackrate noremoteplayback nofullscreen");
  video.disablePictureInPicture = true;
  video.setAttribute("disablePictureInPicture", "");
  video.setAttribute("playsinline", "");
  video.setAttribute("webkit-playsinline", "");

  video.addEventListener("contextmenu", function (e) { e.preventDefault(); });
  player.addEventListener("contextmenu", function (e) { e.preventDefault(); });

  // Retention analytics (funnel-engine/runs/08/analytics/vsl-track.js): every call guarded; a no-op without the tracker.
  function track(name, arg) {
    try { if (window.VSLTrack && typeof window.VSLTrack[name] === "function") window.VSLTrack[name](arg); } catch (err) {}
  }
  var revealTracked = false;
  function trackReveal(how) { if (revealTracked) return; revealTracked = true; track("reveal", how); }
  if (window.VSLTrack) track("attach", video);
  else document.addEventListener("DOMContentLoaded", function () { track("attach", video); });

  video.addEventListener("error", function () {
    if (PROTECTED) {
      if (stream.attached && stream.mode !== "hlsjs") streamFail("media-error-" + (video.error ? video.error.code : 0));
      return;
    }
    if (STORE_SRC || usingFallback) return;
    usingFallback = true;
    video.src = FALLBACK;
    video.load();
    if (MUTED_START) {
      video.muted = true;
      video.play().catch(function () {});
    }
  });

  if (PROTECTED) startStream();
  else if (STORE_SRC) loadStoreSource(STORE_SRC);
  else video.src = PRIMARY;

  if (REVIEW) {
    initReview();
  } else {
    if (MUTED_START) {
      video.muted = true;
      requestPlay().catch(function () {});
    } else {
      // Poster only: no autoplay, no sound, no motion until the visitor taps.
      video.muted = false;
      video.pause();
    }

    applyReveals(Math.max(video.currentTime || 0, savedTime || 0));

    // Reference (page.raw.html): $(".hide").show() on a reload, and on any later load once the btlv2 session cookie
    // exists; the first load sets it. These two show the offer without persisting it (like the reference).
    if (isReload()) { if (showAllReveals()) trackReveal("reload"); }
    if (readCookie(VISIT_COOKIE) === VISIT_VALUE) { if (showAllReveals()) trackReveal("return"); }
    else document.cookie = VISIT_COOKIE + "=" + VISIT_VALUE + "; path=/";

    if (DEBUG_T > 0) {
      keepResumeTime = true;
      pendingResume = DEBUG_T;
      seekTo(DEBUG_T);
    } else if (shouldOfferResume(savedTime)) {
      resumeBox.hidden = false;
    }
    if (resumeBox.hidden) trackPrompt();
  }

  document.getElementById("resume-continue").addEventListener("click", function (e) {
    e.stopPropagation();
    keepResumeTime = true;
    pendingResume = savedTime;
    seekTo(savedTime);
    resumeBox.hidden = true;
    trackPrompt();
    applyReveals(savedTime);
    if (!MUTED_START) startPlayback();   // the choice is the tap: play from here with sound
  });

  document.getElementById("resume-start").addEventListener("click", function (e) {
    e.stopPropagation();
    keepResumeTime = false;
    pendingResume = 0;
    seekTo(0);
    savedTime = 0;
    lastSavedVideoTime = 0;
    try { localStorage.removeItem(LS_TIME); } catch (err) {}
    resumeBox.hidden = true;
    trackPrompt();
    if (!MUTED_START) startPlayback();
  });

  overlay.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (!resumeBox.hidden) return;
    if (unmutedOnce) return;
    if (MUTED_START) startMutedFlowSound();
    else startPlayback();
  });

  // muted mode: the "Click Here" tap restarts the muted preview with sound.
  function startMutedFlowSound() {
    unmutedOnce = true;
    video.muted = false;
    track("unmute");
    if (DEBUG_T > 0) seekTo(DEBUG_T);
    else if (!keepResumeTime) seekTo(0);
    overlay.hidden = true;
    paintCaption(-1);
    rewindBtn.hidden = false;
    requestPlay().catch(function () {});
    syncPauseScreen();
    showControls();
  }

  // sound mode: the first tap. The video is still paused on its poster (or at the ?t= / saved position), so this is
  // the first play, and it is always with sound. The tracker hook that records "unmute" fires once playback starts;
  // if the browser refuses the play (NotAllowedError) the tap target comes back and nothing is recorded.
  function startPlayback() {
    if (unmutedOnce) return;
    unmutedOnce = true;
    video.muted = false;
    if (DEBUG_T > 0) { if (Math.abs((video.currentTime || 0) - DEBUG_T) > 0.35) seekTo(DEBUG_T); }
    else if (!keepResumeTime && (video.currentTime || 0) > 0.35) seekTo(0);
    overlay.classList.add("is-loading");
    rewindBtn.hidden = false;
    var p = requestPlay();
    var started = function () { track("unmute"); };
    var refused = function (err) {
      if (err && err.name === "AbortError") { started(); return; }   // interrupted by a seek/pause, not refused
      unmutedOnce = false;
      overlay.classList.remove("is-loading");
      overlay.hidden = false;
      rewindBtn.hidden = true;
      syncPauseScreen();
    };
    if (p && p.then) p.then(started, refused);
    else started();
    syncPauseScreen();
    showControls();
  }

  // Loading state ends when frames actually move; the overlay then goes away.
  video.addEventListener("playing", function () {
    if (!MUTED_START && unmutedOnce) {
      overlay.hidden = true;
      overlay.classList.remove("is-loading");
    }
  });

  // Captions while muted: painted every frame while the muted preview plays (timeupdate alone lags up to 250 ms).
  var captionRaf = 0;
  function captionLoop() {
    captionRaf = 0;
    if (unmutedOnce || video.paused) return;
    paintCaption(video.currentTime || 0);
    captionRaf = requestAnimationFrame(captionLoop);
  }
  if (cues.length) {
    video.addEventListener("playing", function () { if (!captionRaf) captionRaf = requestAnimationFrame(captionLoop); });
  }

  // There is no mute control on our UI and the sound-on flow never plays muted.
  video.addEventListener("volumechange", function () {
    if (!MUTED_START && !REVIEW && unmutedOnce && video.muted) video.muted = false;
  });

  player.addEventListener("click", function (e) {
    if (!unmutedOnce) return;
    if (e.target.closest(".resume")) return;
    if (video.paused) requestPlay().catch(function () {});
    else { stream.wantPlay = false; video.pause(); }
  });

  // Pause screen: any tap on it (button included) resumes where the viewer left off.
  pauseScreen.addEventListener("click", function (e) {
    e.stopPropagation();
    requestPlay().catch(function () {});
  });
  keepBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    requestPlay().catch(function () {});
  });

  // -10 s: the only seek a viewer can make. Forward seeking stays blocked by the "seeking" guard.
  rewindBtn.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    rewind();
    showControls();
  });

  // Hover devices: the reference shows its controls on pointer movement and hides them when idle.
  player.addEventListener("mousemove", showControls);
  player.addEventListener("mouseleave", function () {
    clearTimeout(controlsTimer);
    player.classList.remove("show-controls");
  });

  video.addEventListener("play", syncPauseScreen);
  video.addEventListener("pause", syncPauseScreen);
  video.addEventListener("ended", function () {
    syncPauseScreen();
    fireEndCta();
    try { localStorage.removeItem(LS_TIME); } catch (err) {}
  });

  video.addEventListener("loadedmetadata", function () {
    if (swapAt > 0) seekTo(swapAt);
    else if (pendingResume > 0) seekTo(pendingResume);
    if (shouldOfferResume(savedTime) && !keepResumeTime && !unmutedOnce && savedTime >= (video.duration || 0) - 0.4) {
      resumeBox.hidden = true;
    }
    updateProgress();
  });

  video.addEventListener("timeupdate", function () {
    if (swapAt >= 0) {
      // A recovery is landing: wait until the new source plays at the old time.
      if (video.readyState < 2 || Math.abs((video.currentTime || 0) - swapAt) > 1.5) return;
      swapAt = -1;
    }
    lastLegalTime = video.currentTime;
    updateProgress();
    if (!unmutedOnce) paintCaption(video.currentTime || 0);
    // Only real (unmuted) viewing moves the offer clock; a ?t= preview playing muted must not reveal early.
    if (unmutedOnce) applyReveals(clockTime());
    if (video.currentTime >= endCtaAt) fireEndCta();
    if (video.currentTime - lastSavedVideoTime >= 5) saveTime();
  });

  video.addEventListener("seeking", function () {
    if (REVIEW || allowSeek) return;
    // During a recovery swap the legal time is the swap point (the new source starts near it; hls.js lands within a
    // frame or two). Anything farther is a viewer seek and goes back, exactly as outside a swap.
    var legal = swapAt >= 0 ? swapAt : lastLegalTime;
    if (Math.abs(video.currentTime - legal) > (swapAt >= 0 ? 1.5 : 0.35)) {
      video.currentTime = legal;
    }
  });

  video.addEventListener("ratechange", function () {
    if (!REVIEW && video.playbackRate !== 1) video.playbackRate = 1;
  });

  window.addEventListener("keydown", function (e) {
    var key = e.key;
    if (REVIEW) {
      reviewKey(e);
      return;
    }
    var seekKeys = {
      ArrowLeft: 1, ArrowRight: 1, ArrowUp: 1, ArrowDown: 1,
      Home: 1, End: 1, PageUp: 1, PageDown: 1,
      j: 1, l: 1, J: 1, L: 1
    };
    if (seekKeys[key] || /^[0-9]$/.test(key)) {
      e.preventDefault();
      e.stopPropagation();
      if ((key === "ArrowLeft" || key === "j" || key === "J") && unmutedOnce) rewind();
    }
    if ((key === " " || key === "k" || key === "K") && unmutedOnce) {
      e.preventDefault();
      if (video.paused) requestPlay().catch(function () {});
      else video.pause();
    }
  }, true);

  video.addEventListener("pause", saveTime);
  window.addEventListener("pagehide", saveTime);
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) saveTime();
  });

  function rewind() {
    track("rewind10");
    seekTo(Math.max(0, (video.currentTime || 0) - REWIND_SECONDS));
  }

  function showControls() {
    if (!unmutedOnce) return;
    player.classList.add("show-controls");
    clearTimeout(controlsTimer);
    controlsTimer = setTimeout(function () {
      player.classList.remove("show-controls");
    }, CONTROLS_IDLE_MS);
  }

  // The sound prompt's impression: once per page load, when it is actually on screen (not under the resume choice).
  // The tap itself is the existing "unmute" event (how = "click").
  function trackPrompt() {
    if (!SOUND_PROMPT || promptTracked || unmutedOnce) return;
    promptTracked = true;
    try { if (window.VSLTrack && typeof window.VSLTrack.event === "function") window.VSLTrack.event("sound_prompt", PROMPT_LINE || "1"); }
    catch (err) {}
  }

  // Captions for the cut being played: the store player's /v/<id>/ or /p/<id> source (the tracker's video id), else the
  // local cut. A cut without a timeline in captions.js shows none, so a re-cut can never show out-of-sync lines.
  function captionCues() {
    var hosted = /\/[vp]\/([a-z0-9-]{1,32})(\/|$)/.exec(STORE_SRC);
    var all = window.VSL_CAPTIONS || {};
    var list = all[hosted ? hosted[1] : CUT];
    return Array.isArray(list) ? list : [];
  }

  // t < 0 (or sound on) clears the band. Cues are [start, end, text], sorted, non-overlapping.
  function paintCaption(t) {
    if (!cues.length) return;
    var idx = -1;
    if (t >= 0 && !unmutedOnce) {
      var i = cueIndex >= 0 && t >= cues[cueIndex][0] ? cueIndex : 0;
      for (; i < cues.length && cues[i][0] <= t; i++) if (t < cues[i][1]) { idx = i; break; }
    }
    if (idx === cueIndex) return;
    cueIndex = idx;
    captionText.textContent = idx >= 0 ? cues[idx][2] : "";
    captionBox.hidden = idx < 0;
  }

  function clockTime() {
    return Math.max(video.currentTime || 0, savedTime || 0);
  }

  function applyReveals(t) {
    var nodes = document.querySelectorAll("[data-reveal-at]");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var at = parseFloat(el.getAttribute("data-reveal-at"));
      if (!(at >= 0)) continue;
      if (el.classList.contains("is-revealed")) continue;
      if (t >= at || revealed.indexOf(at) !== -1) {
        el.classList.add("is-revealed");
        trackReveal(t >= at && revealed.indexOf(at) === -1 ? "time" : "saved");
        if (revealed.indexOf(at) === -1) {
          revealed.push(at);
          persistRevealed();
        }
      }
    }
  }

  // Returns true when it revealed something that was still hidden.
  function showAllReveals() {
    var nodes = document.querySelectorAll("[data-reveal-at]");
    var changed = false;
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].classList.contains("is-revealed")) changed = true;
      nodes[i].classList.add("is-revealed");
    }
    return changed;
  }

  // Plain hosted source (rollback only; the store normally runs the protected stream): progressive mp4 → video.src;
  // HLS → native where supported (Safari/iOS), else hls.js (window.Hls, loaded by the section only for a .m3u8 URL).
  function loadStoreSource(url) {
    var isHls = /\.m3u8(\?|#|$)/i.test(url);
    if (isHls && !video.canPlayType("application/vnd.apple.mpegurl") && window.Hls && window.Hls.isSupported()) {
      var hls = new window.Hls({ capLevelToPlayerSize: true, startLevel: -1 });
      hls.loadSource(url);
      hls.attachMedia(video);
      return;
    }
    video.src = url;
  }

  // ---------- Protected stream ----------
  // data-video = <worker>/p/<cut>. At page load (not on the tap) a signed, expiring token is minted (POST <base>/mint;
  // retried with backoff until it answers) and comes back with tokened URLs for the AES-128 HLS ladder and a
  // token-gated mp4. The store section starts that mint and the hls.js download in an inline script at the top of the
  // page (window.VSL_MINT / window.VSL_HLSJS) so they run while the rest of the page loads; this file picks them up.
  // Engine: hls.js where classic MSE exists (Android WebView, desktop), native HLS where it doesn't (iOS WKWebView /
  // Safari), the mp4 if neither. Failure ladder, invisible to the viewer: any fatal error (a 403 from an expired token
  // included) → fresh token, same engine, resume at the same second; a second failure within 2 min → the token-gated
  // mp4 at the same second. Play requests made before the source is attached (the sound-mode tap, the muted autoplay)
  // are queued and replayed on attach.
  // QA only: ?vslpath=native|hlsjs|mp4 forces an engine, ?vslttl=<s> mints short-lived tokens (expiry recovery).
  function noop() {}

  function requestPlay() {
    if (stream.attached) {
      var p = video.play();
      return p && p.then ? p : Promise.resolve();
    }
    stream.wantPlay = true;
    // Called inside a tap, this unlocks sound playback for the element (WebKit) before the source exists.
    try { var u = video.play(); if (u && u.catch) u.catch(noop); } catch (err) {}
    return new Promise(function (resolve, reject) { stream.waiters.push([resolve, reject]); });
  }

  function streamLog(what) {
    player.setAttribute("data-stream", stream.mode + (what ? " " + what : ""));
    try { if (what && window.VSLTrack && typeof window.VSLTrack.event === "function") window.VSLTrack.event("vstream", what); }
    catch (err) {}
  }

  function mint() {
    if (stream.minting) return stream.minting;
    var ttl = parseInt(PARAMS.get("vslttl"), 10);
    var url = PROTECTED[1] + "/mint" + (ttl > 0 ? "?ttl=" + ttl : "");
    var attempt = 0;
    var early = window.VSL_MINT;   // the section's inline head start (first attempt only)
    window.VSL_MINT = null;
    stream.minting = new Promise(function (resolve) {
      (function go() {
        var req = early || fetch(url, { method: "POST", mode: "cors", credentials: "omit", cache: "no-store" }).then(function (r) {
          if (!r.ok) throw new Error("mint " + r.status);
          return r.json();
        });
        early = null;
        req.then(function (j) {
          if (!j || !j.hls || !j.mp4) throw new Error("mint body");
          stream.minting = null;
          stream.urls = j;
          resolve(j);
        }).catch(function () {
          attempt++;
          setTimeout(go, Math.min(10000, 400 * Math.pow(2, attempt - 1)));
        });
      })();
    });
    return stream.minting;
  }

  function loadHlsJs() {
    if (window.Hls) return Promise.resolve();
    if (window.VSL_HLSJS) return window.VSL_HLSJS;
    var src = player.getAttribute("data-hls-src");
    if (!src) return Promise.reject(new Error("no hls.js"));
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      var timer = setTimeout(function () { reject(new Error("hls.js timeout")); }, 15000);
      s.src = src;
      s.async = true;
      s.onload = function () { clearTimeout(timer); resolve(); };
      s.onerror = function () { clearTimeout(timer); reject(new Error("hls.js load")); };
      document.head.appendChild(s);
    });
  }

  function canNative() { return !!video.canPlayType("application/vnd.apple.mpegurl"); }

  function startStream() {
    var force = PARAMS.get("vslpath");
    var mse = !!(window.MediaSource || window.WebKitMediaSource);
    var mode = force === "native" || force === "hlsjs" || force === "mp4" ? force
      : mse ? "hlsjs" : canNative() ? "native" : "mp4";
    var lib = mode === "hlsjs" ? loadHlsJs().catch(noop) : null;
    Promise.all([mint(), lib]).then(function () {
      if (mode === "hlsjs" && !(window.Hls && window.Hls.isSupported())) mode = canNative() ? "native" : "mp4";
      attachStream(mode, 0);
    });
  }

  function attachStream(mode, t) {
    if (stream.hls) { try { stream.hls.destroy(); } catch (err) {} stream.hls = null; }
    stream.mode = mode;
    stream.mediaRecovered = false;
    if (t > 0) { swapAt = t; lastLegalTime = t; }
    if (mode === "hlsjs") {
      var H = window.Hls;
      // Start on the lowest rung without hls.js's bandwidth-test fragment (it would load segment 0 twice): a 1 Mbps
      // first estimate picks 360p, whose first segment the page already warmed; ABR climbs from the next segments.
      // enableWorker false: transmuxing on the main thread. Measured 2026-10-13 (DEV, 3 A/B pairs): spinning up the
      // transmux worker held the first segment 0.35–1.1 s; on the main thread it parses in 15–45 ms.
      var hls = new H({ capLevelToPlayerSize: true, startLevel: -1, startPosition: t > 0 ? t : -1, enableWorker: false,
        testBandwidth: false, abrEwmaDefaultEstimate: 1000000, backBufferLength: 30, maxMaxBufferLength: 60 });
      hls.on(H.Events.ERROR, function (ev, data) {
        if (!data || !data.fatal || stream.hls !== hls) return;
        if (data.type === H.ErrorTypes.MEDIA_ERROR && !stream.mediaRecovered) {
          stream.mediaRecovered = true;
          hls.recoverMediaError();
          return;
        }
        streamFail("hls-" + data.details);
      });
      stream.hls = hls;
      hls.loadSource(stream.urls.hls);
      hls.attachMedia(video);
    } else {
      video.src = mode === "native" ? stream.urls.hls : stream.urls.mp4;
    }
    stream.attached = true;
    streamLog("");
    if (stream.wantPlay) {
      stream.wantPlay = false;
      var waiters = stream.waiters.splice(0);
      var p = video.play();
      if (!(p && p.then)) p = Promise.resolve();
      p.then(function () { waiters.forEach(function (w) { w[0](); }); },
        function (err) { waiters.forEach(function (w) { w[1](err); }); });
    }
  }

  function streamFail(why) {
    if (stream.recovering) return;
    stream.recovering = true;
    var now = Date.now();
    if (now - stream.lastFail > 120000) stream.fails = 0;
    stream.fails++;
    stream.lastFail = now;
    var t = swapAt >= 0 ? swapAt : video.currentTime || 0;
    // Resume playing only if it was playing (or should be: the muted preview); a viewer's pause stays a pause.
    stream.wantPlay = stream.wantPlay || !video.paused || (MUTED_START && !unmutedOnce);
    var next = stream.mode !== "mp4" && stream.fails < 2 ? stream.mode : "mp4";
    if (next === "mp4" && stream.mode === "mp4" && ++stream.mp4Rescues > 5) { stream.recovering = false; return; }
    streamLog(why + ">" + next);
    stream.attached = false;
    stream.urls = null;
    mint().then(function () {
      stream.recovering = false;
      attachStream(next, t);
    });
  }

  // Reference: onTime(1990) of its 1991.5 s video clicks #scrollcta, as its end-card countdown reaches "2".
  // Ours fires at #scrollcta[data-at] (the "2" of our countdown) or on "ended", whichever comes first; visitor view only.
  function fireEndCta() {
    if (endCtaFired || REVIEW || !unmutedOnce || !endCta) return;
    endCtaFired = true;
    showAllReveals();
    endCta.click();
  }

  function readCookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function isReload() {
    try {
      var nav = performance.getEntriesByType("navigation")[0];
      if (nav) return nav.type === "reload";
    } catch (err) {}
    return !!(performance.navigation && performance.navigation.type === 1);
  }

  function cutSrc(cut) {
    return "../render/vsl-final" + (cut ? "-" + cut : "") + ".mp4";
  }

  // Reference "fake bar" (ConverteAI smartplayer v4, fakeBar alpha=2): width = sqrt(1 - (1 - u)^2), u = time / duration.
  // Measured on the Salazar VSL every 30 s (runs/08/video/player/qa/reference-progress-curve.json): 24.5 % at 3 % of
  // the runtime, 71.6 % at 30 %, 86.4 % at 50 %, 99 % at 86 %. Fast at the start, decelerating all the way to 100 %.
  function updateProgress() {
    var T = video.duration;
    if (!(T > 0) || !isFinite(T)) {
      progressBar.style.width = "0%";
      return;
    }
    var u = Math.min(1, Math.max(0, video.currentTime / T));
    var displayed = Math.sqrt(1 - (1 - u) * (1 - u));
    progressBar.style.width = (displayed * 100) + "%";
  }

  function seekTo(t) {
    allowSeek = true;
    try { video.currentTime = Math.max(0, t || 0); }
    catch (err) {}
    lastLegalTime = video.currentTime;
    setTimeout(function () { allowSeek = false; }, 0);
    updateProgress();
  }

  // Only real (unmuted) viewing counts; the muted autoplay preview must not overwrite a saved position.
  function saveTime() {
    if (REVIEW || !unmutedOnce || !video.currentTime || video.ended) return;
    lastSavedVideoTime = video.currentTime;
    try { localStorage.setItem(LS_TIME, String(video.currentTime)); }
    catch (err) {}
  }

  function readSavedTime() {
    try {
      var n = parseFloat(localStorage.getItem(LS_TIME));
      return n > 0 ? n : 0;
    } catch (err) {
      return 0;
    }
  }

  function readRevealed() {
    try {
      var raw = localStorage.getItem(LS_REVEALED);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.map(Number).filter(function (n) { return n >= 0; }) : [];
    } catch (err) {
      return [];
    }
  }

  function persistRevealed() {
    try { localStorage.setItem(LS_REVEALED, JSON.stringify(revealed)); }
    catch (err) {}
  }

  function shouldOfferResume(t) {
    if (!(t >= 1.5)) return false;
    var d = video.duration;
    if (d > 0 && t >= d - 0.4) return false;
    return true;
  }

  function syncPauseScreen() {
    var show = !REVIEW && unmutedOnce && video.paused && !video.ended && resumeBox.hidden;
    if (show === !pauseScreen.hidden) return;
    pauseScreen.hidden = !show;
    if (show) {
      startTyping();
      filmStatic.start();
    } else {
      stopTyping();
      filmStatic.stop();
    }
  }

  // ---------- Review mode ----------

  function initReview() {
    var box = document.getElementById("review");
    var playBtn = document.getElementById("review-play");
    var seek = document.getElementById("review-seek");
    var cur = document.getElementById("review-time");
    var dur = document.getElementById("review-duration");
    var speeds = box.querySelectorAll("[data-rate]");
    var dragging = false;

    document.body.classList.add("is-review");
    box.hidden = false;
    overlay.hidden = true;
    resumeBox.hidden = true;
    unmutedOnce = true;
    video.muted = false;

    // Offer shown at once, without persisting (Blake's normal visits keep the real reveal timing).
    var nodes = document.querySelectorAll("[data-reveal-at]");
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add("is-revealed");

    // Browsers may refuse sound autoplay without a tap; then it waits paused for the play button.
    video.play().catch(function () {});

    playBtn.addEventListener("click", togglePlay);

    seek.addEventListener("input", function () {
      dragging = true;
      cur.textContent = clock(parseFloat(seek.value));
    });
    seek.addEventListener("change", function () {
      dragging = false;
      video.currentTime = parseFloat(seek.value);
    });

    for (var s = 0; s < speeds.length; s++) {
      speeds[s].addEventListener("click", function (e) {
        video.playbackRate = parseFloat(e.currentTarget.getAttribute("data-rate"));
      });
    }

    function paint() {
      var d = video.duration;
      if (d > 0 && isFinite(d)) {
        seek.max = String(d);
        dur.textContent = clock(d);
      }
      if (!dragging) {
        seek.value = String(video.currentTime || 0);
        cur.textContent = clock(video.currentTime || 0);
      }
      playBtn.textContent = video.paused ? "Play" : "Pause";
      for (var k = 0; k < speeds.length; k++) {
        var on = parseFloat(speeds[k].getAttribute("data-rate")) === video.playbackRate;
        speeds[k].setAttribute("aria-pressed", on ? "true" : "false");
      }
      paintChapters();
    }

    ["loadedmetadata", "durationchange", "timeupdate", "seeked", "play", "pause", "ratechange"].forEach(function (n) {
      video.addEventListener(n, paint);
    });
    paint();
    loadChapters();
    loadCuts();
  }

  // Review-only: switch between rendered cuts (render/variants.json: [{"v": "", "label": "…"}, …]) at the same
  // timestamp. v "" plays render/vsl-final.mp4; any other v plays render/vsl-final-<v>.mp4. The URL keeps ?v= so a
  // reload stays on the chosen cut.
  function loadCuts() {
    var box = document.getElementById("review-cuts");
    fetch("../render/variants.json", { cache: "no-store" }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    }).then(function (cuts) {
      if (!cuts || cuts.length < 2) return;
      var current = CUT;
      cuts.forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button";
        b.textContent = c.label;
        b.setAttribute("aria-pressed", c.v === current ? "true" : "false");
        b.addEventListener("click", function () {
          if (c.v === current) return;
          // Hook previews are the first minute only: jumping into one from a full cut starts it from the top;
          // hook-to-hook keeps the timestamp so the same line can be compared.
          var isHook = function (v) { return v.indexOf("hook-") === 0; };
          var t = isHook(c.v) && !isHook(current) ? 0 : video.currentTime || 0;
          var wasPlaying = !video.paused;
          var rate = video.playbackRate;
          current = c.v;
          video.src = cutSrc(c.v);
          video.addEventListener("loadedmetadata", function once() {
            video.removeEventListener("loadedmetadata", once);
            video.currentTime = Math.min(t, video.duration || t);
            video.playbackRate = rate;
            if (wasPlaying) video.play().catch(function () {});
          });
          var u = new URL(location.href);
          u.searchParams.set("v", c.v);
          history.replaceState(null, "", u);
          var all = box.querySelectorAll("button");
          for (var i = 0; i < all.length; i++) all[i].setAttribute("aria-pressed", all[i] === b ? "true" : "false");
        });
        box.appendChild(b);
      });
      box.hidden = false;
    }).catch(function () {});
  }

  function togglePlay() {
    if (video.paused) video.play().catch(function () {});
    else video.pause();
  }

  function reviewKey(e) {
    var tag = e.target && e.target.tagName;
    if (tag === "INPUT" && e.target.type !== "range") return;
    if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
      e.preventDefault();
      e.stopPropagation();
      var step = e.key === "ArrowLeft" ? -REVIEW_SEEK_SECONDS : REVIEW_SEEK_SECONDS;
      var d = video.duration > 0 ? video.duration : Infinity;
      video.currentTime = Math.min(d, Math.max(0, (video.currentTime || 0) + step));
    } else if (e.key === " " || e.key === "k" || e.key === "K") {
      if (tag === "BUTTON") return; // Space on a focused button already clicks it.
      e.preventDefault();
      togglePlay();
    }
  }

  // Format written by engine/scripts/build.py: one "M:SS Title" (or "H:MM:SS Title") per line.
  function loadChapters() {
    var list = document.getElementById("review-chapters");
    fetch(CHAPTERS, { cache: "no-store" }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.text();
    }).then(function (text) {
      text.split(/\r?\n/).forEach(function (line) {
        var m = /^\s*(?:(\d+):)?(\d+):(\d{2})\s+(.+?)\s*$/.exec(line);
        if (!m) return;
        var t = (parseInt(m[1] || "0", 10) * 3600) + parseInt(m[2], 10) * 60 + parseInt(m[3], 10);
        var li = document.createElement("li");
        var btn = document.createElement("button");
        btn.type = "button";
        var stamp = document.createElement("span");
        stamp.className = "chapter-time";
        stamp.textContent = clock(t);
        btn.appendChild(stamp);
        btn.appendChild(document.createTextNode(m[4]));
        btn.addEventListener("click", function () {
          video.currentTime = t;
          video.play().catch(function () {});
        });
        li.appendChild(btn);
        list.appendChild(li);
        chapterItems.push({ t: t, li: li });
      });
      document.getElementById("review-chapters-wrap").hidden = chapterItems.length === 0;
      paintChapters();
    }).catch(function () {
      document.getElementById("review-chapters-wrap").hidden = true;
    });
  }

  function paintChapters() {
    var now = video.currentTime || 0;
    for (var i = 0; i < chapterItems.length; i++) {
      var next = chapterItems[i + 1];
      var on = now >= chapterItems[i].t && (!next || now < next.t);
      chapterItems[i].li.classList.toggle("is-current", on);
    }
  }

  function clock(sec) {
    sec = Math.max(0, Math.floor(sec || 0));
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = sec % 60;
    var mm = h ? (m < 10 ? "0" + m : String(m)) : String(m);
    return (h ? h + ":" : "") + mm + ":" + (s < 10 ? "0" + s : s);
  }

  // ---------- Typewriter ----------

  var chars = splitIntoChars(typed);
  var typeTimer = 0;
  var loopTimer = 0;
  typed.setAttribute("aria-label", typed.textContent.replace(/\s+/g, " ").trim());

  function splitIntoChars(root) {
    var out = [];
    var spans = root.querySelectorAll("span");
    for (var i = 0; i < spans.length; i++) {
      var text = spans[i].textContent;
      spans[i].textContent = "";
      spans[i].setAttribute("aria-hidden", "true");
      for (var c = 0; c < text.length; c++) {
        var ch = document.createElement("span");
        ch.className = "ch";
        ch.textContent = text.charAt(c);
        spans[i].appendChild(ch);
        out.push(ch);
      }
    }
    return out;
  }

  function startTyping() {
    stopTyping();
    if (reducedMotion) {
      for (var i = 0; i < chars.length; i++) chars[i].classList.add("on");
      return;
    }
    var n = 0;
    typeTimer = setInterval(function () {
      if (n >= chars.length) {
        clearInterval(typeTimer);
        typeTimer = 0;
        return;
      }
      chars[n++].classList.add("on");
    }, TYPE_MS);
    loopTimer = setTimeout(startTyping, TYPE_LOOP_MS);
  }

  function stopTyping() {
    clearInterval(typeTimer);
    clearTimeout(loopTimer);
    typeTimer = 0;
    loopTimer = 0;
    for (var i = 0; i < chars.length; i++) chars[i].classList.remove("on");
  }

  // ---------- Film static (old-film dust, scratches, hair, grain, flicker) ----------

  var filmStatic = (function (canvas) {
    var ctx = canvas.getContext("2d");
    var raf = 0;
    var last = 0;
    var w = 0;
    var h = 0;
    var grains = [];
    var grainIndex = 0;
    var scratches = [];
    var hair = null;
    var FRAME_MS = 1000 / 15;

    function resize() {
      var scale = Math.min(window.devicePixelRatio || 1, 2);
      w = Math.max(1, Math.round(canvas.clientWidth * scale));
      h = Math.max(1, Math.round(canvas.clientHeight * scale));
      canvas.width = w;
      canvas.height = h;
      if (!grains.length) grains = [makeGrain(), makeGrain(), makeGrain()];
    }

    function makeGrain() {
      var size = 160;
      var tile = document.createElement("canvas");
      tile.width = size;
      tile.height = size;
      var g = tile.getContext("2d");
      var img = g.createImageData(size, size);
      for (var i = 0; i < img.data.length; i += 4) {
        var v = Math.random() * 255;
        img.data[i] = v;
        img.data[i + 1] = v;
        img.data[i + 2] = v;
        img.data[i + 3] = Math.random() < 0.3 ? 7 : 0;
      }
      g.putImageData(img, 0, 0);
      return ctx.createPattern(tile, "repeat");
    }

    function draw() {
      var unit = w / 360;
      var flicker = Math.random() < 0.06 ? 6 + Math.random() * 8 : Math.random() * 2;
      ctx.fillStyle = "rgb(" + Math.round(flicker) + "," + Math.round(flicker) + "," + Math.round(flicker) + ")";
      ctx.fillRect(0, 0, w, h);

      grainIndex = (grainIndex + 1) % grains.length;
      ctx.fillStyle = grains[grainIndex];
      ctx.fillRect(0, 0, w, h);

      // Dust: small grey specks, a few larger blotches.
      var specks = 16 + Math.floor(Math.random() * 14);
      for (var i = 0; i < specks; i++) {
        var big = Math.random() < 0.06;
        var r = (big ? 1.6 + Math.random() * 2.4 : 0.4 + Math.random() * 1.1) * unit;
        ctx.fillStyle = "rgba(255,255,255," + (big ? 0.3 : 0.1 + Math.random() * 0.35).toFixed(2) + ")";
        ctx.beginPath();
        ctx.ellipse(Math.random() * w, Math.random() * h, r, r * (0.6 + Math.random() * 0.6), Math.random() * 3, 0, 6.2832);
        ctx.fill();
      }

      // Scratches: thin vertical lines that live for a few frames and drift.
      if (Math.random() < 0.25 && scratches.length < 2) {
        scratches.push({ x: Math.random() * w, life: 2 + Math.floor(Math.random() * 6), a: 0.05 + Math.random() * 0.12 });
      }
      ctx.lineWidth = Math.max(1, 0.8 * unit);
      for (var s = scratches.length - 1; s >= 0; s--) {
        var sc = scratches[s];
        sc.x += (Math.random() - 0.5) * 2 * unit;
        ctx.strokeStyle = "rgba(255,255,255," + sc.a.toFixed(2) + ")";
        ctx.beginPath();
        ctx.moveTo(sc.x, 0);
        ctx.lineTo(sc.x + (Math.random() - 0.5) * 3 * unit, h);
        ctx.stroke();
        if (--sc.life <= 0) scratches.splice(s, 1);
      }

      // Hair: an occasional faint loop that sits still for a moment.
      if (!hair && Math.random() < 0.03) {
        hair = { x: Math.random() * w, y: Math.random() * h, r: (18 + Math.random() * 26) * unit, life: 6 + Math.floor(Math.random() * 10) };
      }
      if (hair) {
        ctx.strokeStyle = "rgba(255,255,255,0.22)";
        ctx.lineWidth = Math.max(1, 0.7 * unit);
        ctx.beginPath();
        ctx.ellipse(hair.x, hair.y, hair.r * 0.8, hair.r, 0.3, 0.4, 5.9);
        ctx.stroke();
        if (--hair.life <= 0) hair = null;
      }
    }

    function tick(now) {
      raf = requestAnimationFrame(tick);
      if (now - last < FRAME_MS) return;
      last = now;
      draw();
    }

    return {
      start: function () {
        resize();
        draw();
        if (!reducedMotion && !raf) raf = requestAnimationFrame(tick);
      },
      stop: function () {
        cancelAnimationFrame(raf);
        raf = 0;
        scratches = [];
        hair = null;
      }
    };
  })(film);
})();
